import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import styled from '@emotion/styled';
import { injectIntl } from 'react-intl';
import { titleize } from 'lib/string_utils';
import SessionStore from 'stores/shared/session';
import _ from 'underscore';
import classnames from 'classnames';
import { roundPrice } from 'lib/pricing_utils';
import { Spinner } from 'ui_system/token_auth/elements/Loader';
import UnitPrice from 'views/ui/unit_price';
import BookingRequestStore from 'stores/plugins/booking_request';
import PricingStore from 'stores/plugins/pricing';
import PricingActionCreator from 'action_creators/pricing';
import StoreInterest from 'lib/flux/store/interest_mixin';
import './index.scss';

// component styles

const PriceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FromPriceContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

const FromPriceDescription = styled.div`
  font-size: 16px;
  margin-left: 12px;
  @media only screen and (max-width: 767px) {
    font-size: 13px;
    margin-left: 0px;
  }
`;

const FromPriceTotal = styled.div`
  display: inline-flex;
  margin-left: 5px;
  margin-right: 12px;
  font-size: 21px;
  font-weight: 600;
  @media only screen and (max-width: 767px) {
    font-size: 17px;
  }
`;

const TourPagePrice = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;
const PriceToggle = styled.i`
  display: flex;
`;

const PricingBreakdownContainer = styled.div`
  top: 50px;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
  background-color: #333333;
  color: #fff;
  z-index: 1;
  opacity: 0.95;
  @media only screen and (max-width: 767px) {
    top: 34px;
  }
`;

const CenteredRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0px 20px 0px;
`;

const PricingBreakdownHeader = styled(CenteredRow)`
  font-size: 13px;
`;

const CloseButtonContainer = styled(CenteredRow)``;

const CloseButton = styled.button`
  background: none;
  border: none;
  @media only screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

const PricingLineItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const PriceDescription = styled.div`
  font-size: 18px;
  margin-left: 24px;
`;
const PriceTotal = styled.div`
  font-size: 18px;
  margin-right: 24px;
`;

const DiscountIcon = styled.span`
  display: inline-flex;
  margin-left: 3px;
`;

const DiscountMinus = styled.span`
  font-size: 14px;
  display: flex;
  align-items: center;
`;

const GrandTotalDescription = styled(PriceDescription)`
  font-weight: 600;
`;

const GrandTotal = styled(PriceTotal)`
  font-weight: 600;
`;

const getStateFromPricingStore = function getStateFromPricingStore() {
  return {
    loading: PricingStore.state.get('loading'),
    guests_price_formatted: PricingStore.state.get('guests_price_formatted'),
    unit_price_formatted: PricingStore.state.get('unit_price_formatted'),
    units: PricingStore.state.get('units').toJS(),
    initial_price_formatted: PricingStore.state.get('initial_price_formatted'),
    total_formatted: PricingStore.state.get('total_formatted'),
    booking_fee: PricingStore.state.get('booking_fee'),
    booking_fee_formatted: PricingStore.state.get('booking_fee_formatted'),
    additional_tax: PricingStore.state.get('additional_tax'),
    additional_tax_formatted: PricingStore.state.get(
      'additional_tax_formatted'
    ),
    additional_tax_label: PricingStore.state.get('additional_tax_label'),
    discount: PricingStore.state.get('discount'),
    discount_formatted: PricingStore.state.get('discount_formatted'),
    online_discount: PricingStore.state.get('online_discount'),
    online_discount_formatted: PricingStore.state.get(
      'online_discount_formatted'
    ),
    addonsPrices: PricingStore.state.get('addons').toJS(),
    priceable: PricingStore.state.get('priceable'),
    unitIdForInitialPricing: PricingStore.state.get(
      'unit_id_for_initial_pricing'
    ),
  };
};

const getStateFromBookingStore = function getStateFromBookingStore() {
  return {
    guests: BookingRequestStore.state.get('guests'),
    selectedAddons: BookingRequestStore.state.get('addons'),
    time: BookingRequestStore.state.get('time'),
  };
};

const getStateFromStores = function getStateFromStores() {
  return _.extend({}, getStateFromPricingStore(), getStateFromBookingStore());
};

const PriceComponent = createReactClass({
  displayName: 'TourPage-Price',
  mixins: [StoreInterest],

  propTypes: {
    intl: PropTypes.object.isRequired,
    priceable: PropTypes.string.isRequired,
    selected_addons: PropTypes.array,
    calculated: PropTypes.bool,
    klassName: PropTypes.string,
  },

  getDefaultProps() {
    return {
      selected_addons: [],
      calculated: false,
      klassName: '',
    };
  },

  getInitialState() {
    return _.extend({}, getStateFromStores(), {
      calculated: this.props.calculated,
      showBreakdown: false,
      priceable: this.props.priceable,
      bookingRequestModified: false,
    });
  },

  getStoreInterests() {
    return {
      currency: 'session.currency',
    };
  },

  componentDidMount() {
    BookingRequestStore.changed.add(this._bookingRequestChanged);
    PricingStore.changed.add(this._pricingChanged);
    this._previewPricing();
  },

  componentWillUnmount() {
    BookingRequestStore.changed.remove(this._bookingRequestChanged);
    PricingStore.changed.remove(this._pricingChanged);
  },

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currency !== prevState.currency) {
      this._previewPricing();
    }
  },

  _bookingRequestChanged() {
    this.setState(getStateFromBookingStore(), () => {
      this._previewPricing();
    });
    this.setState({ bookingRequestModified: true });
  },

  _pricingChanged() {
    this.setState(
      _.extend({}, getStateFromPricingStore(), {
        calculated: true,
      })
    );
  },

  _headerPriceClicked() {
    this.setState({ showBreakdown: !this.state.showBreakdown });
  },

  _previewPricing() {
    PricingActionCreator.preview();
  },

  _shouldShowFullPricing() {
    return (
      (this.state.calculated && !!this.state.time) ||
      this.state.bookingRequestModified
    );
  },

  _shouldShowBreakdown() {
    return this._shouldShowFullPricing() && this.state.showBreakdown;
  },

  _shouldShowBreakdownToggle() {
    return this._shouldShowFullPricing() && !this.state.loading;
  },

  _priceDescription() {
    const { intl } = this.props;
    return this._shouldShowFullPricing()
      ? intl.formatMessage({
          defaultMessage: 'Total Price',
          description: 'Label for the total price of a tour or experience',
        })
      : intl.formatMessage({
          defaultMessage: 'From',
          description: 'Prefix indicating starting price (e.g., "From $50")',
        });
  },

  _getAddon(selectedAddon) {
    return _.find(this.state.addonsPrices.items, (addon) => {
      return (
        addon.id &&
        selectedAddon.id &&
        parseInt(addon.id) === parseInt(selectedAddon.id)
      );
    });
  },

  _getLowestPricedUnit(units) {
    let id = this.state.unitIdForInitialPricing;
    let ordered = units.filter((i) => !i.internal_only && i.id === id);
    let lastElement = ordered[ordered.length - 1];
    return lastElement;
  },

  _closeClicked(e) {
    e.preventDefault();
    this.setState({ showBreakdown: false });
  },

  _handlePriceKeyDown(evt) {
    if (!['Enter', ' '].includes(evt.key)) return;
    this._headerPriceClicked();
  },

  _renderHeaderPrice() {
    return (
      <TourPagePrice
        data-testid="tour-price"
        className="TourPage-Price-price"
        onClick={this._headerPriceClicked}
        onKeyDown={this._handlePriceKeyDown}
        role="button"
        tabIndex="0"
      >
        {this._renderHeaderTotal()}
        {this._shouldShowBreakdownToggle()
          ? this._renderBreakdownToggle()
          : null}
      </TourPagePrice>
    );
  },

  _renderHeaderTotal() {
    if (!this.state.units.items) return null;
    const { items } = this.state.units;

    const lowestPrice = this._getLowestPricedUnit(items);

    return roundPrice(
      this._shouldShowFullPricing()
        ? this.state.total_formatted
        : `${lowestPrice.unit_price_formatted}`
    );
  },

  _renderBreakdownToggle() {
    return (
      <PriceToggle
        role="button"
        aria-label="Expands pricing summary"
        className="af-angle-down"
      />
    );
  },

  _renderAddons() {
    const { selectedAddons } = this.state;
    return selectedAddons.toJS().map(this._renderAddon);
  },

  _renderAddon(selectedAddon) {
    let addon = this._getAddon(selectedAddon);
    let view = null;

    if (addon && addon.count > 0) {
      view = (
        <PricingLineItem>
          <PriceDescription>{addon.name}</PriceDescription>
          <PriceTotal>{roundPrice(addon.total_formatted)}</PriceTotal>
        </PricingLineItem>
      );
    }
    return view;
  },

  _renderAdditionalTax() {
    const {
      additional_tax_label: additionalTaxLabel,
      additional_tax_formatted: additionalTaxFormatted,
    } = this.state;
    return (
      <PricingLineItem>
        <PriceDescription>{additionalTaxLabel}</PriceDescription>
        <PriceTotal>{roundPrice(additionalTaxFormatted)}</PriceTotal>
      </PricingLineItem>
    );
  },

  _renderBookingFee() {
    const { intl } = this.props;
    const { booking_fee_formatted: bookingFeeFormatted } = this.state;
    return (
      <PricingLineItem>
        <PriceDescription>
          {titleize(
            intl.formatMessage({
              defaultMessage: 'Service fee',
              description:
                'Label for the service/booking fee in price breakdown',
            })
          )}
        </PriceDescription>
        <PriceTotal>{roundPrice(bookingFeeFormatted)}</PriceTotal>
      </PricingLineItem>
    );
  },

  _renderOnlineDiscount() {
    const { intl } = this.props;
    const { online_discount_formatted: onlineDiscountFormatted } = this.state;
    return (
      <PricingLineItem>
        <PriceDescription>
          {intl.formatMessage({
            defaultMessage: 'Online discount',
            description: 'Label for discount applied when booking online',
          })}
        </PriceDescription>
        <PriceTotal>{roundPrice(onlineDiscountFormatted)}</PriceTotal>

        <DiscountIcon>
          (<DiscountMinus className="icon af-minus-ar" />)
        </DiscountIcon>
      </PricingLineItem>
    );
  },

  _renderDiscount() {
    const { intl } = this.props;
    const { discount_formatted: discountFormatted } = this.state;
    return (
      <PricingLineItem>
        <PriceDescription>
          {intl.formatMessage({
            defaultMessage: 'Discount',
            description: 'Label for a general discount applied to the booking',
          })}
        </PriceDescription>
        <PriceTotal>
          {roundPrice(discountFormatted)}
          <DiscountIcon>
            (<DiscountMinus className="icon af-minus-ar" />)
          </DiscountIcon>
        </PriceTotal>
      </PricingLineItem>
    );
  },

  _renderUnits() {
    const {
      units: { items },
    } = this.state;
    return items?.filter((unit) => unit.count > 0).map(this._renderUnit);
  },

  _renderUnit(unit) {
    const { total_formatted: totalFormatted } = unit;
    return (
      <PricingLineItem>
        <PriceDescription>
          <UnitPrice unit={unit} />
        </PriceDescription>
        <PriceTotal>{roundPrice(totalFormatted)}</PriceTotal>
      </PricingLineItem>
    );
  },

  _renderBreakdown() {
    const { intl } = this.props;
    const {
      additional_tax: additionalTax,
      booking_fee: bookingFee,
      discount,
      online_discount: onlineDiscount,
      total_formatted: totalFormatted,
    } = this.state;
    return (
      <PricingBreakdownContainer>
        <PricingBreakdownHeader>
          {intl.formatMessage({
            defaultMessage: "Here's the breakdown",
            description: 'Header text for the detailed price breakdown section',
          })}
        </PricingBreakdownHeader>
        {this._renderUnits()}

        {this._renderAddons()}

        {discount > 0 ? this._renderDiscount() : null}

        {additionalTax > 0 ? this._renderAdditionalTax() : null}

        {onlineDiscount > 0 ? this._renderOnlineDiscount() : null}

        {bookingFee > 0 ? this._renderBookingFee() : null}
        <PricingLineItem>
          <GrandTotalDescription>
            {intl.formatMessage({
              defaultMessage: 'Total',
              description: 'Label for the grand total in the price breakdown',
            })}
          </GrandTotalDescription>
          <GrandTotal>{roundPrice(totalFormatted)}</GrandTotal>
        </PricingLineItem>
        <CloseButtonContainer>
          <CloseButton
            data-testid="close-pricing-link"
            onClick={this._closeClicked}
          >
            {intl.formatMessage({
              defaultMessage: 'Close',
              description: 'Button text to close the price breakdown modal',
            })}
          </CloseButton>
        </CloseButtonContainer>
      </PricingBreakdownContainer>
    );
  },

  render() {
    const {
      loading,
      units: { items: unitItems },
      selectedAddons,
    } = this.state;
    const addonItems = selectedAddons.toJS();
    const priceAffectedByAddons = addonItems.some((addon) => {
      const total = this._getAddon(addon)
        ? this._getAddon(addon).total
        : undefined;
      return Number(total) > 0;
    });
    const zeroPricedUnits =
      !!unitItems && unitItems.filter((e) => e.unit_price == 0);
    if (
      !!unitItems &&
      unitItems.length === zeroPricedUnits.length &&
      !priceAffectedByAddons
    ) {
      return null;
    }
    const componentClass = `TourPage-Price ${this.props.klassName || ''}`;
    const headerClass = classnames('TourPage-Price-header', {
      calculated: this.state.calculated,
    });

    return (
      <PriceContainer
        className={componentClass}
        aria-expanded={this._shouldShowBreakdown()}
      >
        <FromPriceContainer className={headerClass}>
          <FromPriceDescription
            className="tour-from-price-description"
            data-testid="total-price"
          >
            {this._priceDescription()}
          </FromPriceDescription>
          <FromPriceTotal className="tour-from-price-total">
            {loading ? (
              <Spinner color="white" className="tour-price-spinner" />
            ) : (
              this._renderHeaderPrice()
            )}
          </FromPriceTotal>
        </FromPriceContainer>
        {this._shouldShowBreakdown() ? this._renderBreakdown() : null}
      </PriceContainer>
    );
  },
});

export const Price = injectIntl(PriceComponent);
